/**
 * Path + query of an absolute URL, for use as a same-origin router `to` target.
 * Returns `undefined` when {@link url} is not a valid absolute URL.
 */
export const toSameOriginPath = (url: string): string | undefined => {
  try {
    const { pathname, search } = new URL(url);
    return `${pathname}${search}`;
  } catch {
    return undefined;
  }
};

/**
 * Get a URL search param
 * NOTE: If window.URLSearchParams is not defined, this will return undefined.
 * @param param - The parameter to get
 * @param url - The URL to get the parameter from. If not provided, the window.location.search will be used.
 * @returns URLSearchParams
 */
export const getUrlParam = (
  param: string,
  url?: string,
): string | undefined => {
  if (typeof window === 'undefined') {
    return undefined;
  }

  if (typeof window.URLSearchParams !== 'undefined') {
    return (
      new URLSearchParams(url ?? window.location.search).get(param) ?? undefined
    );
  }
};
